module.exports = __webpack_public_path__ + "img/tw.7bced80f.svg";